/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Tab, Title } from 'src/components';
import { DashboardLayout } from 'src/containers';
import AccountInfoTab from './AccountInfoTab';
import BusinessInfoTab from './BusinessInfoTab';
import CustomerAppTab from './CustomerAppTab';
import KitchenDisplayStatus from './KitchenDisplayStatus';
import LoyaltyPoints from './LoyaltyPoints';
import PasswordTab from './PasswordTab';
import DeliveryCharge from './DeliveryCharge';
import Others from './Others';
import useFetch from 'src/hooks/useFetch';
import { shallowEqual, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import Qrs from './Qr';
import Loader from 'src/components/loader';
import Address from '../restaurant/details/Address';
import WorkingHours from '../restaurant/details/WorkingHours';
import OnlineOrdering from '../restaurant/details/OnlineOrdering';
import DeliveryZone from '../restaurant/details/DeliveryZone';
import OrderTypes from '../restaurant/details/OrderTypes';
import PaymentMethod from '../restaurant/details/AddPayment/PaymentMethod';
import TaxesTab from '../restaurant/details/Taxes';
import SocailMedia from '../restaurant/details/SocailMedia';
import GoogleAnalytics from '../restaurant/details/GoogleAnalytics';
import ImageSlider from 'src/components/ImageSlider';
import About from '../restaurant/details/About';
import ServicesTab from '../business/ServicesTab';
import WiFiQr from './WiFiQr';
import CurrencySettings from '../restaurant/details/Currency';

interface IProps {}

const Settings = () => {
  // const [activeTabIndex, setActiveIndex] = React.useState(0);
  const [isSubmittingImageSlider, setisSubmittingImageSlider] =
    useState<boolean>(false);
  const [activeTabIndex, setActiveIndex] = React.useState(
    Number(localStorage.getItem('activeTabIndex')) || 0
  );
  const { detailsData, loading, error } = useSelector(
    ({ detailsData }: RootState) => detailsData,
    shallowEqual
  );
  useEffect(() => {
    localStorage.setItem('activeTabIndex', activeTabIndex.toString());
  }, [activeTabIndex]);
  let tabData = [
    // {
    //   id: 4,
    //   label: 'Customer App',
    // },
    // {
    //   id: 5,
    //   label: 'Kitchen Display Status',
    // },
    // {
    //   id: 6,
    //   label: 'Loyalty Points',
    // },
    // {
    //   id: 7,
    //   label: 'Taxes',
    // },
    // {
    //   id: 8,
    //   label: 'Others',
    // },
    // {
    //   id: 3,
    //   label: ' Payment QR',
    // },
    {
      id: 0,
      label: 'Business Information',
    },
    {
      id: 1,
      label: 'Account Information',
    },
    // {
    //   id: 2,
    //   label: 'General Settings',
    // },
    {
      id: 2,
      label: 'Password Setting',
    },
    {
      id: 3,
      label: 'About',
      lock: false,
    },
    // {
    //   id: 4,
    //   label: 'Images',
    //   lock: false,
    // },

    {
      id: 4,
      label: 'Working Hours',
      lock: false,
    },
    {
      id: 5,
      label: 'Online Ordering',
      lock: true,
    },

    {
      id: 6,
      label: 'Delivery Zone',
      lock: true,
    },
    {
      id: 7,
      label: 'Loyalty',
      lock: true,
    },
    {
      id: 8,
      label: 'Order Types',
      // lock: true,
    },

    {
      id: 9,
      label: 'Payment Method',
      lock: false,
    },
    {
      id: 10,
      label: 'Extra Charges',
      lock: false,
    },
    {
      id: 11,
      label: 'Social Media',
      lock: false,
    },
    {
      id: 12,
      label: 'Google Analytics',
      lock: false,
    },
    {
      id: 13,
      label: 'Services',
      lock: false,
    },
    {
      id: 14,
      label: 'Image Sliders',
      lock: false,
    },
    {
      id: 15,
      label: 'WiFi QR',
      lock: false,
    },
    {
      id: 16,
      label: 'Currency',
      lock: false,
    }
  ];

  return (
    <div className="grid grid-cols-12 gap-9 mt-6 text-black ">
      <div className="md:col-span-3 col-span-12   ">
        <Tab
          activeIndex={activeTabIndex}
          setActiveIndex={setActiveIndex}
          tabData={tabData}
        />
      </div>
      <div className="md:col-span-9 col-span-12">
        {
          activeTabIndex === 0 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 mb-10">
              <BusinessInfoTab />
            </div>
          ) : activeTabIndex === 1 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6">
              <AccountInfoTab />
            </div>
          ) : //  : activeTabIndex === 2 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[388px] p-6">
          //     <DeliveryCharge />
          //   </div>
          // )
          activeTabIndex === 2 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6">
              <PasswordTab />
            </div>
          ) : // : activeTabIndex === 4 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[437px] p-6">
          //     <CustomerAppTab />
          //   </div>
          // )
          //  activeTabIndex === 5 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[388px] p-6">
          //     <KitchenDisplayStatus />
          //   </div>
          // ) :
          // :activeTabIndex === 6 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[388px] p-6">
          //     <LoyaltyPoints />
          //   </div>
          // )
          // : activeTabIndex === 8 ? (
          //   <Others />
          // )
          // activeTabIndex === 7 ? (
          //   <div className=" w-[488px]">
          //     <Taxes />
          //   </div>
          // )
          // :
          // activeTabIndex === 3 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[488px] p-6">
          //     <Qrs />
          //   </div>
          // ) :
          // activeTabIndex === 3 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[488px] p-6">
          //     <Qrs />
          //   </div>
          // )
          // :
          //
          activeTabIndex === 3 ? (
            <div className=" ">
              <About detailData={detailsData} loading={loading} />
            </div>
          ) : // activeTabIndex === 4 ? (
          //   <div className="rounded-xl border border-border-color-dark w-[388px] p-6 mb-10 ">
          //     {loading ? (
          //       <Loader />
          //     ) : (
          //       <Address address={detailsData} loading={loading} />
          //     )}
          //   </div>
          // ) :
          activeTabIndex === 4 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
              {loading ? (
                <Loader />
              ) : (
                <WorkingHours
                  workingHours={detailsData?.workingHours}
                  loading={loading}
                />
              )}
            </div>
          ) : activeTabIndex === 5 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
              {loading ? <Loader /> : <OnlineOrdering />}
            </div>
          ) : activeTabIndex === 6 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
              {loading ? (
                <Loader />
              ) : (
                <DeliveryZone detailsData={detailsData} loading={loading} />
              )}
            </div>
          ) : activeTabIndex === 8 ? (
            <>
              {loading ? (
                ''
              ) : (
                <div className="rounded-xl border border-border-color-dark w-[518px] p-6 ">
                  <OrderTypes
                    allowedOrderTypes={detailsData?.allowedOrderTypes}
                    loading={loading}
                  />
                </div>
              )}
            </>
          ) : activeTabIndex === 9 ? (
            <div className="rounded-xl border border-border-color-dark w-[690px] p-6 pr-0 pl-4  -ml-4 mb-5">
              {/* <OrderTypes
                    allowedOrderTypes={detailsData?.allowedOrderTypes}
                  /> */}
              <PaymentMethod loading={loading} />
            </div>
          ) : activeTabIndex === 10 ? (
            <div className=" w-[518px] p-6 ">
              {loading ? <Loader /> : <TaxesTab />}
            </div>
          ) : activeTabIndex === 11 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
              <SocailMedia
                socialLinks={detailsData?.socialLinks}
                loading={loading}
              />
            </div>
          ) : activeTabIndex === 12 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
              <GoogleAnalytics gtag={detailsData?.gTag} loading={loading} />
            </div>
          ) : activeTabIndex === 13 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
              <ServicesTab />
            </div>
          ) : activeTabIndex === 14 ? (
            <div className="rounded-xl border border-border-color-dark w-[800px] p-6">
              <ImageSlider
                slider="imageSlider"
                isSubmitting={isSubmittingImageSlider}
                SetIsSubmitting={setisSubmittingImageSlider}
              />
            </div>
          ) : activeTabIndex === 15 ? (
            <div className=" ">
              <WiFiQr />
            </div>
          ) : activeTabIndex === 16 ? (
            <div className="rounded-xl border border-border-color-dark w-[388px] p-6">
              <CurrencySettings />
            </div>
          ) : null
          //
        }
      </div>
    </div>
  );
};

export default React.memo(Settings);
